// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1895":"77367d406c917d28","2733":"cb855682d7ea07e0"}[chunkId] + ".css";
};